import NewsItemAudienceInfo from "./news-item-audience-info.vue";

window.Vue.createApp({
    components: {
        NewsItemAudienceInfo,
    },
}).mount("#audience-info-container");
